import { useState, useCallback } from 'react'
import { PAGINATION } from '@/constants'

const STORAGE_PREFIX = 'pageSize_'

function readStoredSize(storageKey: string, fallback: number): number {
  try {
    const saved = localStorage.getItem(storageKey)
    if (saved == null) return fallback
    const parsed = Number(saved)
    if (!Number.isFinite(parsed) || parsed < 1) return fallback
    return Math.min(PAGINATION.MAX_SIZE, Math.floor(parsed))
  } catch {
    return fallback
  }
}

export function usePersistentPageSize(
  key: string,
  defaultValue: number = PAGINATION.DEFAULT_SIZE,
): [number, (size: number) => void] {
  const storageKey = `${STORAGE_PREFIX}${key}`

  const [size, setSize] = useState<number>(() => readStoredSize(storageKey, defaultValue))

  const setPersistedSize = useCallback(
    (next: number) => {
      setSize(next)
      try {
        localStorage.setItem(storageKey, String(next))
      } catch {
        // ignore storage errors (quota, private mode, etc.)
      }
    },
    [storageKey],
  )

  return [size, setPersistedSize]
}

export default usePersistentPageSize
